/**
 * Get the PDF URL for the printable gift message assets
 *
 * @param {Date} date - now (new Date()) or order date
 * @param {Object} options - { forceDefault<bool>, holiday<bool>, }
 * @return {String} printablePdfUrl
 */
export const getPrintableByDate = (date, {
	forceDefault=false,
	holiday=false,
} = {}) => {
	const defaultUrl = "https://sell.cratejoy.com/wp-content/uploads/2022/05/Generic-Gift-Card.pdf";
	const holidayUrl = "https://sell.cratejoy.com/wp-content/uploads/2022/11/Holiday-Printable-2022.pdf";
	if (forceDefault) {
		return defaultUrl;
	}
	if (holiday) {
		return holidayUrl;
	}
	const orderMonth = date.getMonth(); // NB: January = 0, December = 11
	const mothersDay = [3, 4].includes(orderMonth); // April, May
	const fathersDay = orderMonth == 5; // June
	const valentinesDay = orderMonth === 1; // February
	const tisTheSeason = orderMonth >= 10; // Nov, Dec
	return mothersDay ? "https://sell.cratejoy.com/wp-content/uploads/2022/03/Mothers-Day.pdf" :
		tisTheSeason ? holidayUrl :
			valentinesDay ? "https://sell.cratejoy.com/wp-content/uploads/2022/02/Valentines-Day-Printable-Layout.pdf" :
				fathersDay ? "https://sell.cratejoy.com/wp-content/uploads/2021/06/Fathers-Day-2021-Printable-Card.pdf" :
					defaultUrl;
};

export default getPrintableByDate;
